// extracted by mini-css-extract-plugin
module.exports = {"BackButton":"loanAppplicationDetailFees_BackButton__h9ULw","ActionContainer":"loanAppplicationDetailFees_ActionContainer__UheBz"};